<template>
    <div class="hint" v-if="ifHint">
        <i class="el-icon-error"></i>
        <span>{{msg}}</span>
    </div>
</template>

<script>
    export default {
        name: "customHint",
        props:{
            msg:{
                type:String
            },
            ifHint:{
                type:Boolean
            }
        }
    }
</script>

<style scoped lang="scss">
    .el-dialog__title{
        font-size: 16px;
    }
    .hint{
        border:1px solid #e55c63;
        background: #ffe6e5;
        font-size: 14px;
        color:#666666;
        height: 40px;
        /*width: 320px;*/
        line-height: 40px;
        .el-icon-error{
            color:#f5222d;
            font-weight: 500;
            margin: 0 15px;
        }
    }
</style>
